import React from "react";
import LayoutsHome from "../Components/Layouts/LayoutsHome";
import "../styles/TermsStyle.css"; // Separate CSS for styling
import { Helmet } from "react-helmet-async";

function TermsAndConditions() {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Spectacular Seminars</title>

        <meta
          name="description"
          content="Read the Terms and Conditions for using Spectacular Seminars, including website usage policies, event registration terms, payment conditions, cancellations, and user responsibilities."
        />

        <meta
          name="keywords"
          content="terms and conditions, Spectacular Seminars terms, website terms, event registration terms, seminar booking policy, cancellation policy, user agreement"
        />
      </Helmet>
      <LayoutsHome>
        <div className="terms-container">
          <h1 className="terms-title">Terms and Conditions</h1>
          <p className="terms-date">Effective Date: 01/05/2025</p>

          <section className="terms-section">
            <h2 className="terms-heading">Welcome</h2>
            <p className="terms-text">
              Welcome to Spectacular Seminars. By accessing or using our website
              at{" "}
              <a
                href="https://spectacularseminars.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://spectacularseminars.com
              </a>{" "}
              ("Site"), you agree to be bound by these Terms and Conditions
              ("Terms"). If you do not agree with these Terms, please do not use
              our Site or services.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">1. Who We Are</h2>
            <p className="terms-text">
              Spectacular Seminars ("we", "us", or "our") provides educational
              and motivational seminars, webinars, and resources for personal
              and professional development. We are based in the United States
              and operate in accordance with applicable U.S. laws.
            </p>
            <p className="terms-text">
              <strong>Contact Information:</strong>
              <br />
              Phone: 855-454-2448
              <br />
              Email: host@spectacularseminars.com
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">2. Use of the Site</h2>
            <p className="terms-text">
              You may use the Site only for lawful purposes and in accordance
              with these Terms. You agree not to:
            </p>
            <ul className="terms-list">
              <li>Violate any applicable laws or regulations;</li>
              <li>Use the Site for any fraudulent or harmful purpose;</li>
              <li>
                Attempt to gain unauthorized access to any portion of the Site.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">3. Intellectual Property</h2>
            <p className="terms-text">
              All content on this Site—including but not limited to text,
              graphics, logos, videos, and seminar materials—is the property of
              Spectacular Seminars or its content suppliers and is protected by
              copyright, trademark, and other laws.
            </p>
            <p className="terms-text">
              You may not copy, reproduce, distribute, or create derivative
              works from any part of the Site without our prior written
              permission.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">
              4. Seminar Registrations and Payments
            </h2>
            <p className="terms-text">
              By registering for a seminar or webinar, you agree to provide
              accurate information and to pay all applicable fees. We reserve
              the right to refuse or cancel your registration at our sole
              discretion.
            </p>
            <p className="terms-text">
              <strong>Cancellation Policy:</strong> Refunds or credits may be
              issued in accordance with our separate refund policy, which will
              be made available at the point of registration or upon request.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">5. Disclaimer of Warranties</h2>
            <p className="terms-text">
              The Site and its content are provided “as is” without warranties
              of any kind, either express or implied. We make no representations
              or warranties about the accuracy, completeness, or suitability of
              the content on this Site.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">6. Limitation of Liability</h2>
            <p className="terms-text">
              To the fullest extent permitted by law, Spectacular Seminars shall
              not be liable for any damages arising out of your use of—or
              inability to use—the Site or any seminar content.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">7. Links to Third-Party Sites</h2>
            <p className="terms-text">
              Our Site may contain links to third-party websites. These links
              are provided for your convenience only. We are not responsible for
              the content, policies, or practices of any third-party sites.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">8. Privacy Policy</h2>
            <p className="terms-text">
              Your use of the Site is also governed by our Privacy Policy, which
              explains how we collect, use, and protect your personal data.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">9. Changes to These Terms</h2>
            <p className="terms-text">
              We reserve the right to modify these Terms at any time. Changes
              will be effective immediately upon posting on the Site. Your
              continued use of the Site after changes are posted constitutes
              your acceptance of the updated Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">10. Governing Law</h2>
            <p className="terms-text">
              These Terms are governed by and construed in accordance with the
              laws of the State of [Insert State], United States, without regard
              to its conflict of law principles.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-heading">11. Contact Us</h2>
            <p className="terms-text">
              If you have any questions about these Terms, please contact us at:
              <br />
              Spectacular Seminars
              <br />
              Email: host@spectacularseminars.com
              <br />
              Phone: 855-454-2448
              <br />
              Website:{" "}
              <a
                href="https://spectacularseminars.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://spectacularseminars.com
              </a>
            </p>
          </section>
        </div>
      </LayoutsHome>
    </>
  );
}

export default TermsAndConditions;
